import { render, staticRenderFns } from "./PageGameStake.vue?vue&type=template&id=3468b81c&lang=pug"
import script from "./PageGameStake.vue?vue&type=script&lang=js"
export * from "./PageGameStake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports